import { BaseModel } from '../base-model';
import { IPropertySmartSuggest } from './';

export interface IPropertySmartSuggestion {
  Input?: string;
  GoalId?: number | null;
  SelectedInputEntries?: IPropertySmartSuggest[];
  SelectedRegionEntries?: any;
}
export class PropertySmartSuggestion extends BaseModel<IPropertySmartSuggestion> implements IPropertySmartSuggestion {
  Input?: string;
  GoalId?: number | null;
  SelectedInputEntries?: IPropertySmartSuggest[];
  SelectedRegionEntries?: any;
  /**
   *
   */
  constructor(selectedInput?: IPropertySmartSuggest[], regionDestination?: any,
    option?: { input?: string, goalId?: number }) {
    super();
    this.SelectedInputEntries = selectedInput;
    this.SelectedRegionEntries = regionDestination;
    this.Input = option.input;
    this.GoalId = option.goalId;
  }
}